import Vue from 'vue';
import Vuex from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);

export const store = new Vuex.Store({
	state: {

		settings: {
			Language: {
				texts: {
					Title: 't-language',
					ddTitle: 't-select-language'
				},
				type: 'dropdown',
				selected: 0,
				items: [
					{ name: 'English' },
					{ name: 'German' },
					{ name: 'French' },
					{ name: 'Chinese' },
					{ name: 'Indian' },
					{ name: 'Italian' },
					{ name: 'Spanish' },
					{ name: 'Portugese' },
					{ name: 'Dutch' },
					{ name: 'Russian' }
				]
			},
			CompressedAirFlow: {
				texts: {
					Title: 't-compressed-air-flow'
				},
				type: 'tab',
				selected: 0,
				items: [
					{ name: 'l/s' },
					{ name: 'CFM' },
					{ name: 'm³/h' },
					{ name: 'm³/min' }
				]
			},
			Pressure: {
				texts: {
					Title: 't-pressure'
				},
				type: 'tab',
				selected: 0,
				items: [
					{ name: 'Bar' },
					{ name: 'Psi' }
				]
			},
			Temperature: {
				texts: {
					Title: 't-temperature'
				},
				type: 'tab',
				selected: 0,
				items: [
					{ name: '°C' },
					{ name: '°F' }
				]
			},
			CoolingWaterflow: {
				texts: {
					Title: 't-cooling-water-flow'
				},
				type: 'tab',
				selected: 0,
				items: [
					{ name: 'l/s' },
					{ name: 'gpm' }
				]
			},
			CoolingWaterInput: {
				texts: {
					Title: 't-cooling-water-input'
				},
				type: 'tab',
				selected: 0,
				items: [
					{ name: 'Flow' },
					{ name: 'Delta T' }
				]
			},
			GlycolType: {
				texts: {
					Title: 't-Glycol-type'
				},
				type: 'tab',
				selected: 0,
				items: [
					{ name: 'Ethylene' },
					{ name: 'Propylene' }
				]
			},
			GlycolConcentrationInCoolingWater: {
				texts: {
					Title: 't-glycol-concetration-in-cooling-water'
				},
				type: 'input',
				defaultValue: 0,
				value: 0,
				maxValue: 60,
				inputParam: null
			},
			ReferenceTemperature: {
				texts: {
					Title: 't-reference-temperature'
				},
				type: 'input',
				defaultValue: 25,
				value: 25,
				inputParam: "Temperature"
			},
			ReferencePressure: {
				texts: {
					Title: 't-reference-pressure'
				},
				type: 'input',
				defaultValue: 1,
				value: 1,
				inputParam: "Pressure"
			},
			ReferenceRelativeHumidity: {
				texts: {
					Title: 't-reference-relative-humidity'
				},
				type: 'input',
				defaultValue: 0,
				value: 0,
				maxValue: 100,
				inputParam: null
			}
		}

	},
	getters: getters,
	mutations: mutations,
	actions: actions
});


// WEBPACK FOOTER //
// ./src/store/store.js